var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Comments50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#673AB7",
    d: "M39,6H9C7.343,6,6,7.343,6,9v33l8.556-8H39c1.656,0,3-1.344,3-3V9C42,7.343,40.656,6,39,6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1C4E9",
    d: "M10 14H38V16H10zM10 19H38V21H10zM10 24H26V26H10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Comments50);
export default __webpack_public_path__ + "static/media/icons8-comments-50.208208a1ab252509583c3280974a125d.svg";
export { ForwardRef as ReactComponent };